import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
import { IPaymentMethodListResponseApi } from 'src/app/interfaces/financial/payment-method.interface';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {
  private readonly http = inject(HttpClient);

  formFilterList = new FormGroup({
    searchText: new FormControl(''),
    changeType: new FormControl(''),
    status: new FormControl(''),
    page: new FormControl(1),
    pageSize: new FormControl(5),
    sortBy: new FormControl(''),
    sortOrder: new FormControl(''),
  });

  listAll(payload: {
    pageSize: number;
    page: number;
    status?: string;
    changeType?: string;
    searchText?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams()
      .set('page', payload.page)
      .set('pageSize', payload.pageSize);

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.changeType) {
      params = params.set('changeType', payload.changeType);
    }

    if (payload.searchText) {
      params = params.set('searchText', payload.searchText);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get<any>(
      `${environment.api}/paymentMethods/all`, { params }
    );
  }

  export(payload: {
    status?: string;
    changeType?: string;
    searchText?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams();

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.changeType) {
      params = params.set('changeType', payload.changeType);
    }

    if (payload.searchText) {
      params = params.set('searchText', payload.searchText);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get(
      `${environment.api}/paymentMethods/all/export`,
      { params, responseType: 'blob' }
    );
  }

  register(body: any) {
    if (body.id) {
      return this.update(body);
    } else {
      return this.create(body);
    }
  }

  create(body: any) {
    return this.http.post<any>(`${environment.api}/paymentMethods/create`, body);
  }

  update(body: any) {
    return this.http.put<any>(`${environment.api}/paymentMethods/update/${body.id}`, body);
  }

  delete(id: string) {
    return this.http.delete(`${environment.api}/paymentMethods/delete/${id}`).pipe(
      (res) => res,
      (error) => error
    );
  }

  toggle(id: string, status: boolean) {
    return this.http.patch(`${environment.api}/paymentMethods/${id}/change-status`, { status }).pipe(
      (res) => res,
      (error) => error
    );
  }

  getById(id: string) {
    return this.http.get<any>(`${environment.api}/paymentMethods/${id}`);
  }

  getBySelect(payload: {
    searchText?: string;
    pageSize: number;
    page: number;
  }) {
    let params = new HttpParams()
      .set('page', payload.page)
      .set('pageSize', payload.pageSize)
      .set('status', 'true')

    if (payload.searchText) {
      params = params.set('searchText', payload.searchText);
    }

    return this.http.get<IPaymentMethodListResponseApi>(
      `${environment.api}/paymentMethods/all`, {
        params, headers: new HttpHeaders().set('x-skip-loading', 'true'),
      }
    );
  }
}
